var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4820_2564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4820_2564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7155 6.57542C15.45 7.58182 15.8173 8.71643 15.8173 9.97925C15.8173 11.2421 15.45 12.3767 14.7155 13.3831C13.981 14.3895 13.0128 15.0839 11.8109 15.4664V16.7581C13.3675 16.3425 14.6327 15.5097 15.6065 14.2597C16.5803 13.0097 17.0672 11.5829 17.0672 9.97925C17.0672 8.37563 16.5803 6.94882 15.6065 5.69884C14.6327 4.44884 13.3675 3.61604 11.8109 3.20044V4.49209C13.0128 4.87456 13.981 5.569 14.7155 6.57542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1137 8.20442C12.8071 7.64941 12.3728 7.21912 11.8109 6.91356V13.0866C12.3728 12.7811 12.8071 12.3508 13.1137 11.7958C13.4203 11.2407 13.5736 10.6422 13.5736 10.0001C13.5736 9.358 13.4203 8.75945 13.1137 8.20442Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82365 15.6571L6.24996 12.0834H3.15704V7.91677L6.24996 7.94723L9.82365 4.34311V15.6571ZM4.407 9.16675H6.94546L8.57367 7.53854V12.6251L6.782 10.8334H4.407V9.16675Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.dc77ffb8f0365ea9b4d50d3a6ec16776.svg";
export { ForwardRef as ReactComponent };